import BaseReducer from "./BaseReducer";

class PhotoReducer extends BaseReducer {
  domain = "Camera";
  type = "Image";

  initialState = {
    photo: null,
    updatePhoto: false,
    showCropper: false,
    showCamera: false,
    isProcessing: false,
    croppedAreaPixels: null,
  };
}

const reducer = new PhotoReducer();

export default reducer;
